import * as React from "react";
import { forwardRef } from "react";
const SvgSquare = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 44, height: 44, viewBox: "0 0 44 44", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 1.39551, y: 1.39532, width: 41.8753, height: 41.8753, rx: 11.632, fill: "#1A2023" }), /* @__PURE__ */ React.createElement("rect", { x: 10.7012, y: 10.7017, width: 23.2641, height: 23.2641, rx: 2.32641, fill: "white" }), /* @__PURE__ */ React.createElement("rect", { x: 16.5176, y: 16.5168, width: 11.632, height: 11.632, fill: "#1A2023" }));
const ForwardRef = forwardRef(SvgSquare);
export { ForwardRef as ReactComponent };
